import React, { useEffect, useState } from 'react';
import { useLanguage } from '../../../context/language';
import Loading from '../../../assets/loading.gif';
import 'jquery-ui-dist/jquery-ui';
import { callPayokApi, getDeposit } from '../../../api/fastcoinService';
import { getURLBackToPanel } from '../../../context/brokersUrl';
import 'jquery-ui-dist/jquery-ui';
import { getStrLang } from '../../Translate';


const PayokPayment = (props) => {

    const { translate, lang } = useLanguage();
    const [loadingPayokInfo, setLoadingPayokInfo] = useState(false);
    const [infoPayok, setInfoPayok] = useState(sessionStorage.getItem("payok_info") !== null ? JSON.parse(sessionStorage.getItem("payok_info")) : {});
    const [waitingPayment, setWaitingPayment] = useState(sessionStorage.getItem("waiting_payment") !== null ? JSON.parse(sessionStorage.getItem("waiting_payment")) : false);
    const [isError, setIsError] = useState(false)
    const [errorMsg, setErrorMsg] = useState("")
    const [customerAccount, setCustomerAccount] = useState("")

    useEffect(() => {
        translate();
    }, [translate]);



    const callPayokPayment = () => {
        setLoadingPayokInfo(true);
        if (infoPayok[props.payment_type] === undefined) {
            const additionalData = {};
            // Add customerAccount for Thailand payments if required
            if (customerAccount) {
                additionalData.customerAccount = customerAccount;
            }
            
            callPayokApi(sessionStorage.getItem("order_no"), props.payment_type.replace('payok_', ''), additionalData)
                .then(res => {
                    if (res && res.success && res.data) {
                        // Extract payment URL from content field
                        const paymentUrl = res.data.paymentInfo?.content || 
                                         res.paymentInfo?.content || 
                                         res.data.paymentInfo?.paymentUrl || 
                                         res.data.paymentUrl;
                        if (paymentUrl) {
                            const paymentData = {
                                paymentUrl: paymentUrl,
                                platformOrderId: res.data.platformOrderId,
                                merchantOrderId: res.data.merchantOrderId
                            };
                            setInfoPayok({ ...infoPayok, [props.payment_type]: paymentData });
                            sessionStorage.setItem("payok_info", JSON.stringify({ ...infoPayok, [props.payment_type]: paymentData }));
                        } else {
                            setErrorMsg("Payment URL not received from server.");
                            setIsError(true);
                        }
                    } else {
                        setErrorMsg(res?.message || "Please, talk with the Administrator.");
                        setIsError(true);
                    }
                })
                .catch(err => {
                    console.log(err.toString());
                    setErrorMsg(err.response?.data?.message ? err.response?.data?.message : "Internal server error")
                    setIsError(true)
                }).finally(() => {
                    setLoadingPayokInfo(false);
                    translate();
                });
        }

    }

    useEffect(() => {
        let timeout;
        function checkPayment() {
            timeout = setTimeout(function () {
                getDeposit(sessionStorage.getItem("order_no"))
                    .then(res => {
                        if (res.status.toLowerCase() === "paid") {
                            setWaitingPayment(false);
                            sessionStorage.setItem("waiting_payment", false);
                            window.location.replace(getURLBackToPanel());
                        } else {
                            checkPayment();
                        }
                    })
                    .catch(err => {
                        alert(err);
                        checkPayment();
                    })
            }, 30000);
        }
        if (waitingPayment) {
            sessionStorage.setItem("waiting_payment", true);
            checkPayment();
        }
        return () => clearTimeout(timeout);
    }, [loadingPayokInfo]);


    useEffect(() => {
        if (infoPayok[props.payment_type] === undefined) {
            // Check if the payment method requires additional input (e.g., Thailand needs customerAccount)
            const needsCustomerAccount = sessionStorage.getItem("country")?.toUpperCase() === 'TH';
            if (!needsCustomerAccount) {
                callPayokPayment();
            }
        }
        return () => {
            const iframe = document.getElementById('payok_frame');
            if (iframe) {
                iframe.removeEventListener('load',()=>{})
            }
        }
    }, [])
    const [loading, setLoading] = useState(true);

    const handleLoad = () => {
        setLoading(false);
    };

    useEffect(() => {
        const handleMessage = (event) => {
            if (event.data && event.data.type === 'redirected') {
                const redirectedUrl = event.data.url;
                window.location.href=redirectedUrl
            }
        }
        window.addEventListener('message', handleMessage);
        return () => {
            window.removeEventListener('message', handleMessage);
        };
    }, []);

    const handleCustomerAccountChange = (e) => {
        setCustomerAccount(e.target.value);
    };

    const callApi = (e) => {
        e.preventDefault();
        callPayokPayment();
    }
    
    return (
        <>
            {loadingPayokInfo && <div className="group-pix-content">
                <div className="pix-container">
                    <div className="grup-crypto-opt">
                        <div className="msg-pix">
                            <img src={Loading} alt={"loading"} width="30px" height="30px" />
                        </div>
                    </div>
                </div>
            </div>}


            {loadingPayokInfo === false && infoPayok[props.payment_type] === undefined && sessionStorage.getItem("country")?.toUpperCase() === 'TH' && <>
                <div className='col-md-12 d-flex justify-content-center mt-5'>
                    <form style={{ minWidth: "100%" }} onSubmit={callApi}>
                        <div className='form-group'>
                            <label htmlFor="customer_account">{getStrLang(lang.nameLang, "account_number") || "Account Number"}</label>
                            <input type="text" className='form-control' id="customer_account" name="customer_account"
                                placeholder={`${getStrLang(lang.nameLang, "enter")} ${getStrLang(lang.nameLang, "account_number") || "Account Number"}`} 
                                value={customerAccount} onChange={handleCustomerAccountChange}
                                required />
                        </div>
                        <button type='submit' className='btn btn-primary btn-block'>{getStrLang(lang.nameLang, "pay")}</button>
                    </form>
                </div>
            </>}

            <div className=''>
                {infoPayok[props.payment_type] !== undefined ?
                    <>
                        <div style={{ width: '100%' }}>
                            <div style={{ display: 'flex', flexDirection: 'row', width: '100%', alignItems: 'center', justifyContent: 'center' }}>
                                {loading && <div className="loader"> <img src={Loading} alt={"loading"} width="30px" height="30px" /></div>}
                            </div>

                            <iframe
                                id='payok_frame'
                                src={`${infoPayok[props.payment_type]['paymentUrl']}`}
                                title={`${props.payment_type}`}
                                width="100%"
                                height="800px"
                                onLoad={handleLoad}
                                style={{ display: loading ? 'none' : 'block' }}
                            />
                        </div>
                    </>
                    :
                    <>
                    </>
                }

                {isError && <div style={{ display: 'flex', flexDirection: 'row', width: '100%', alignItems: 'center', justifyContent: 'center' }}>
                    <h4>{errorMsg}</h4>
                </div>}
            </div>

        </>
    )
}

export default PayokPayment;